<template>
    <div class="contact-banner mb-2 rounded-12 mb-6 position-relative">
        <div class="contact-banner__elements">
            <ContactDialogBannerEllipse1 class="contact-banner__element contact-banner__element--top"></ContactDialogBannerEllipse1>
            <ContactDialogBannerEllipse2 class="contact-banner__element contact-banner__element--bottom"></ContactDialogBannerEllipse2>
        </div>

        <p class="contact-banner__title text-center">
            If you're inquiring about an offer, please follow these steps for support:
        </p>

        <div class="contact-banner__offer-support-steps d-flex flex-sm-row flex-column justify-space-between mt-8">
            <div class="d-flex flex-sm-column align-center align-sm-start mb-2 mb-sm-0">
                <StepsChip class="flex-shrink-1 mb-sm-2">Step 1</StepsChip>
                <span class="ml-2 ml-sm-0">Navigate to
                    <strong @click="goToMyOffersPage">My Offers</strong>.
                </span>
            </div>

            <div class="d-flex flex-sm-column align-center align-sm-start mb-2 mb-sm-0">
                <StepsChip class="flex-shrink-1 mb-sm-2">Step 2</StepsChip>
                <span class="ml-2 ml-sm-0">Select your specific offer.</span>
            </div>

            <div class="d-flex flex-sm-column align-center align-sm-start">
                <StepsChip class="flex-shrink-1 mb-sm-2">Step 3</StepsChip>
                <span class="ml-2 ml-sm-0">Click on <strong>Support</strong>.</span>
            </div>
        </div>
    </div>
</template>

<script setup>

import StepsChip from "./Steps-Chip.vue";
import ContactDialogBannerEllipse1 from "./Elements/Contact-Dialog-Banner-Ellipse-1.vue";
import ContactDialogBannerEllipse2 from "./Elements/Contact-Dialog-Banner-Ellipse-2.vue";

</script>